import { ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { Router, NavigationEnd, RouterModule } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { filter } from 'rxjs/operators';
import { configModel } from 'src/models/config.model';
import { AppConfig } from 'src/app/app.config';
import { UserAccessService } from 'src/services/useraccess.service';
import { Access, Screen } from 'src/Utilities/enum';
import { CommonService } from 'src/services/common.service';
import { AppService } from 'src/app/app.service';
import { AuthStore } from 'src/app/store/authorization/auth.store';
import { AuthService } from 'src/services/auth.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-admin-header',
  templateUrl: './admin-header.component.html',
  styleUrls: ['./admin-header.component.css'],
  standalone: true,
  imports: [CommonModule,RouterModule]
})
export class AdminHeaderComponent implements OnInit {

  ck = new configModel();
  hcontact = this.ck.getConfigkeyname('Header_Contact');
  public webRoot: string;
  public redirectUrl: string;
  public landingUrl: string;
  public tenantId: string;
  public applicantsUrl: string;
  public iqviauserId: string;
  public roleId: number;
  public siteConfigPermission: Access = Access.NoAccess;
  public questionLibararyPermission: Access = Access.NoAccess;
  public studyIsVisible: Access = Access.NoAccess;
  public isApplicantVisisble: Access = Access.NoAccess;
  public restrictPermission: Access = Access.NoAccess;
  public isAdminUser: boolean = false;
  private readonly authStore = inject(AuthStore);
  
  // Track active tab
  public activeTab: string = '';
  permissionsOfScreen: any[];
  
  constructor(
    private userAccessService: UserAccessService, 
    private userStateService: AppService, 
    private commonService: CommonService,
    private authService: AuthService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private http: HttpClient,
  ) { }

  ngOnInit() {
     this.webRoot = AppConfig.appsettings.navigatorRoot;
    this.redirectUrl = this.normalizeRedirectUrl(AppConfig.appsettings.redirectUrl); 
    this.tenantId = AppConfig.appsettings?.tenantId ?? '';
    this.applicantsUrl = `${this.webRoot}admin#/adminhome/Participants`;
    this.iqviauserId =  this.userStateService.getCurrentUserId() || '';
    if (this.iqviauserId) {
      this.userAccessService.getUserAccessByUserId(this.iqviauserId).subscribe(
        (Roledata) => {
          this.authStore.setUserAccessData(Roledata);
          this.getuserPermissionData();
          this.GetUserPermissionByRoleId(Roledata[0].RoleId);
        },
        (error) => { }
      );
    }
    
    // Track route changes to update active tab
    this.updateActiveTab(this.router.url);
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.updateActiveTab(event.urlAfterRedirects);
    });
  }
  
  updateActiveTab(url: string) {
    // Normalize URL to lowercase for comparison
    const normalizedUrl = url.toLowerCase();
    
    // Check specific routes by searching for keywords in the URL
    if (normalizedUrl.includes('questionlibrary') || normalizedUrl.includes('addnewquestions')) {
      this.activeTab = 'questionlibrary';
    }
    else if (normalizedUrl.includes('participants') || normalizedUrl.includes('admin-participant-answers')) {
      this.activeTab = 'participants';
    }
    else if (normalizedUrl.includes('groupmember') || normalizedUrl.includes('group-member-details')) {
      this.activeTab = 'groupmember';
    }
    else if (normalizedUrl.includes('restriction') || normalizedUrl.includes('addrestriction')) {
      this.activeTab = 'restriction';
    }
    else if (normalizedUrl.includes('siteconfiguration')) {
      this.activeTab = 'siteconfiguration';
    }
    else if (normalizedUrl.includes('studydetail') || normalizedUrl.includes('addnewpre')) {
      this.activeTab = 'studies';
    }
    else if (normalizedUrl.includes('adminhome') && !normalizedUrl.includes('participants') && !normalizedUrl.includes('group-member')) {
      this.activeTab = 'studies';
    }
  }
  
  isTabActive(tabName: string): boolean {
    return this.activeTab === tabName;
  }

  getuserPermissionData() {
    this.roleId = this.authStore.currentRoleId();
    if (this.roleId) {
      this.userAccessService.getuserPermissionData(this.roleId).subscribe(
        (Permissiondata) => {
          this.authStore.setPermissionData(Permissiondata)
        },
        (error) => { }
      );
    } else {
      window.location.href = this.webRoot;
    }
  }

  siteConfigurationIsVisible(roleId: number): boolean {
      this.siteConfigPermission = this.GetPermissionValueByScreenAndRole(Screen.SiteConfiguration, roleId);
    return this.siteConfigPermission !== Access.NoAccess;
  }

  questionLibraryIsVisible(roleId: number): boolean {
    this.questionLibararyPermission = this.GetPermissionValueByScreenAndRole(Screen.QuestionLibrary, roleId);
    return this.questionLibararyPermission !== Access.NoAccess;
  }

  studytabIsVisible(roleId: number): boolean { 
    this.studyIsVisible = this.GetPermissionValueByScreenAndRole(Screen.Study, roleId);
    return this.studyIsVisible !== Access.NoAccess;
  }

  applicantsTabIsVisible(roleId: number): boolean { 
    this.isApplicantVisisble = this.GetPermissionValueByScreenAndRole(Screen.Applicant, roleId);
    return this.isApplicantVisisble !== Access.NoAccess;
  }
  
  restrictTabIsVisible(roleId: number): boolean { 
    this.restrictPermission = this.GetPermissionValueByScreenAndRole(Screen.Restriction, roleId);
    return this.restrictPermission !== Access.NoAccess;
  }

  signOut(): void {
    this.clearClientSession();
    const logoutUrl = `${this.redirectUrl}Home/Logout`;
    this.http.get(logoutUrl, { responseType: 'text' }).subscribe({
      next: () => {
        window.location.href = this.redirectUrl;
      },
      error: () => {
        window.location.href = this.redirectUrl;
      }
    });
  }

  private clearClientSession(): void {
    this.authStore.reset();
    this.userStateService.clearCurrentUserId();
    sessionStorage.clear();
    localStorage.clear();
  }

  GetPermissionValueByScreenAndRole(screenId: number, roleId: number): Access {
    const permissionRecord = this.permissionsOfScreen.find((p: any) => {
      if (!p) return false;
      return  p.ScreenId === screenId && p.RoleId === roleId;
    });
    if (permissionRecord && permissionRecord.Permission !== undefined) {
      return permissionRecord.Permission;
    }
    return Access.NoAccess;
  }

  GetUserPermissionByRoleId(roleId:number) {
    this.roleId = this.authStore.currentRoleId();
    this.userAccessService.GetUserPermissionByRoleId(roleId).subscribe(
      (Permissiondata) => {
        Promise.resolve().then(() => {
          this.permissionsOfScreen = Permissiondata;
          this.studytabIsVisible(this.roleId);
          this.questionLibraryIsVisible(this.roleId);
          this.applicantsTabIsVisible(this.roleId);
          this.siteConfigurationIsVisible(this.roleId);
          this.restrictTabIsVisible(this.roleId);
          this.cdr.markForCheck();
        });
      });
  }

  private normalizeRedirectUrl(url: string): string {
    const source = (url && url.trim().length > 0) ? url.trim() : this.webRoot;
    if (!source) {
      return '/';
    }

    let normalized = source.replace(/\/admin\/?$/i, '/');
    if (!normalized.endsWith('/')) {
      normalized += '/';
    }

    return normalized;
  }
}
